module.exports = __webpack_public_path__ + "static/media/medocs_04_full.2eb25e91.jpg";